import { render, staticRenderFns } from "./AdminPageEdit.vue?vue&type=template&id=2fd6ba3e&"
import script from "./AdminPageEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports